<div class="flex h-full cursor-pointer items-center" [class.expanded]="expanded()">
  <div class="flex h-full">
    @for (_ of [].constructor(nestingLevel()); track $index) {
      <span class="node-padding"></span>
    }
  </div>

  <mat-checkbox
    class="scale-75"
    [checked]="selected()"
    [indeterminate]="indeterminate()"
    (change)="onCheckboxChangeHandler($event)"
    (click)="$event.stopPropagation()"
    color="primary"
  ></mat-checkbox>

  <span class="node-content flex w-full items-center gap-2 overflow-hidden">
    <ng-content></ng-content>

    <span class="truncate text-xs text-gray-700" [matTooltipPosition]="'right'" [matTooltip]="node().name">
      {{ node().name }}
    </span>

    <ng-content select="[extra-content]"></ng-content>

    @if (isGroup()) {
      <dojo-icon
        [size]="'m'"
        class="node-content-icon chevron ml-auto"
        [icon]="expanded() ? 'chevron-down' : 'chevron-right'"
      />
    }
  </span>
</div>
